import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import dbService from "../../firebase/dbService";
import { query, where } from "firebase/firestore";
import { participantsCollectionRef } from "../../config/firebaseConfig";

export const fetchParentsStudents = createAsyncThunk(
    "auth/fetchParentsStudents",
    async ({ parentUid }, { rejectWithValue }) => {
        const q = query(
            participantsCollectionRef,
            where("parentUid", "==", parentUid)
        );
        try {
            const students = await dbService.getDocsWithQuery(q);
            return students;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const initialState = {
    students: [],
    loading: false,
    error: null,
};

export const parentStudentsSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchParentsStudents.pending, (state, action) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchParentsStudents.fulfilled, (state, action) => {
                state.loading = false;
                state.students = action.payload;
                state.error = null;
            })
            .addCase(fetchParentsStudents.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default parentStudentsSlice.reducer;
